import React from 'react';
import { motion } from 'motion/react';
import { getRevealProps, premiumTransition, defaultViewport } from '../motion/scrollMotion';
import ScrollReveal from './ScrollReveal';
import './TestimonialsSection.css';

const testimonials = [
  {
    quote: "Proven InfoSec's penetration testing team found gaps our previous vendor missed entirely. The reporting was clear enough for both our engineers and our board to act on immediately.",
    author: "CISO",
    title: "Financial Services",
    company: "",
    color: "#00a9e0"
  },
  {
    quote: "Their SOC team feels like an extension of ours. Alerts are triaged fast, escalations are meaningful, and we've cut our false-positive noise dramatically since onboarding.",
    author: "Head of IT Security",
    title: "Healthcare Group",
    company: "",
    color: "#00d084"
  },
  {
    quote: "We needed ISO 27001 certification on a tight timeline. Proven InfoSec's advisors built the roadmap, closed our gaps, and got us through the audit on the first attempt.",
    author: "VP of Engineering",
    title: "SaaS Company",
    company: "",
    color: "#333"
  }
];

const TestimonialsSection = () => {
  return (
    <ScrollReveal as="section" className="testimonials-section" variant="fadeUp">
      {/* The Sky Gradient Background - Only at the top */}
      <div className="sky-gradient">
        <div className="stars-container">
          {[...Array(30)].map((_, i) => (
            <div key={i} className="tiny-star" style={{ 
              top: `${Math.random() * 80}%`, 
              left: `${Math.random() * 100}%`,
              opacity: Math.random() * 0.5 + 0.2
            }}></div>
          ))}
        </div>
      </div>

      {/* Content Area - Starts in the white background */}
      <div className="testimonials-content">
        <motion.div className="testimonials-header" {...getRevealProps('fadeUp')}>
          <h2 className="testimonials-title">What Our Customers Are Saying</h2>
        </motion.div>

        <div className="testimonials-grid">
          {testimonials.map((item, index) => (
            <motion.div
              key={index}
              className="testimonial-card"
              initial={{ opacity: 0, y: 40, filter: 'blur(8px)' }}
              whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
              viewport={defaultViewport}
              transition={premiumTransition(index * 0.12)}
            >
              <div className="card-content">
                <p className="quote">"{item.quote}"</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </ScrollReveal>
  );
};

export default TestimonialsSection;
